import { createModel } from '@/store/tools';

const dataList = { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 };
const model = {
    namespace: 'operatingrule',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getRewardRuleList': T('getRewardRuleList'),
            'getRewardRuleDetail': T('getRewardRuleDetail'),
            'getRewardType': T('getRewardType'),

            'getSendRuleList': T('getSendRuleList'),
            'getSendRuleState': T('getSendRuleState'),
            'getSendDetail': T('getSendDetail'),

            'getTimeoutDetail': T('getTimeoutDetail'),

            'getEvaluateTypes': T('getEvaluateTypes'),
            'getEvaluateInfos': T('getEvaluateInfos'),

            'getCancelRuleList': T('getCancelRuleList'),
            'getCancelRulePre': T('getCancelRulePre'),
            //充值规则
            'getTopUpRules': T('getTopUpRules'),
            'getTopUpRuleInfo': T('getTopUpRuleInfo'),
        },
        actions: {
            //奖惩规则
            'getRewardRuleList': A('getRewardRuleList'), // 列表数据
            'getRewardRuleDetail': A('getRewardRuleDetail'), // 详情数据
            'getCleanDetail': C('getRewardRuleDetail'), // 清除详情数据
            'getRewardType': A('getRewardType'), // 类型(奖励/惩罚)


            //派单规则
            'getSendRuleList': A('getSendRuleList'), // 列表数据
            'getSendRuleState': A('getSendRuleState'), // 规则状态
            'getSendDetail': A('getSendDetail'), // 派单详情数据
            'getSendCleanDetail': C('getSendDetail'), // 派单清除详情数据

            //超时规则
            'getTimeoutDetail': A('getTimeoutDetail'), // 超时规则初始数据

            //评价规则
            'getEvaluateTypes': A('getEvaluateTypes'),//评价星级列表
            'getEvaluateInfos': A('getEvaluateInfos'),//评价内容列表

            //取消规则
            'getCancelRuleList': A('getCancelRuleList'), // 取消规则列表数据
            'getCancelRulePre': A('getCancelRulePre'), // 获取上一条取消规则
            'getCleanCancelRulePre': C('getCancelRulePre'), // 清除获取上一条取消规则
            //充值规则
            'getTopUpRules': A('getTopUpRules'),
            'getTopUpRuleInfo': A('getTopUpRuleInfo'),
        },
        sagas: {
            'getRewardRuleList': S('getRewardRuleList', '/reward/rule/list'),
            'getRewardRuleDetail': S('getRewardRuleDetail', '/reward/rule/detail', 'POST', 'id'),
            'getRewardType': S('getRewardType', '/enum/RiderRewardEnum'),

            'getSendRuleList': S('getSendRuleList', '/?cmd=com.xqxc.api.pig.mis.biz.rules.DispatchRuleService.findDispatch'),
            'getSendRuleState': S('getSendRuleState', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getSendDetail': S('getSendDetail', '/?cmd=com.xqxc.api.pig.mis.biz.rules.DispatchRuleService.detail', 'POST'),

            'getTimeoutDetail': S('getTimeoutDetail', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderRulesParamService.findParams'),

            'getEvaluateTypes': S('getEvaluateTypes', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.findStars'),
            'getEvaluateInfos': S('getEvaluateInfos', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.findContents'),

            'getCancelRuleList': S('getCancelRuleList', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderCancelRuleMisService.findRules'),
            'getCancelRulePre': S('getCancelRulePre', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderCancelRuleMisService.lastRule'),
            //充值规则
            'getTopUpRules': S('getTopUpRules', '/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.listRule'),
            'getTopUpRuleInfo': S('getTopUpRuleInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.ruleDetail'),
        },
        reducers: {
            'rewardRuleList': R('getRewardRuleList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'details': R('getRewardRuleDetail', {}),
            'rewardType': R('getRewardType', []),

            'sendRuleList': R('getSendRuleList', dataList),
            'ruleState': R('getSendRuleState', []),
            'sendDetail': R('getSendDetail', {}),

            'timeoutDetail': R('getTimeoutDetail', {}),

            'evaluateTypes': R('getEvaluateTypes', []),
            'evaluateInfos': R('getEvaluateInfos', dataList),

            'cancelList': R('getCancelRuleList', dataList),
            'cancelPre': R('getCancelRulePre', {}),
            //充值规则
            'topUpRules': R('getTopUpRules', []),
            'topUpRuleInfo': R('getTopUpRuleInfo', {}),
        }
    })
};
export default createModel(model);